<template>
  <div class="mainLayout">
    <main-top-bar></main-top-bar>
    <div class="viewContentRoute">
      <router-view></router-view>
    </div>
    <common-bottom></common-bottom>
  </div>
</template>

<script>
import mainTopBar from "@/components/content/mainTopBar";
import commonBottom from "@/components/content/commonBottom";

export default {
  name: "mainLayout",
  components: {
    mainTopBar,
    commonBottom,
  },
}
</script>

<style scoped lang="scss">
.mainLayout{
  display: flex;
  min-height:100%;
  flex-direction: column;
  .viewContentRoute{
    flex:1;
  }
}

</style>
